import { IUserWithPortalAccess } from 'src/generated-types'

export type MainNavItem = {
  name: string
  access?: keyof IUserWithPortalAccess | string
  /** Stable integration id; DB links to a feature row. */
  integrationKey?: string
}

export function hasMainNavAccess(
  user: IUserWithPortalAccess | undefined,
  nav: MainNavItem,
  isIntegrationEnabled: (integrationKey: string) => boolean,
): boolean {
  if (nav.integrationKey && !isIntegrationEnabled(nav.integrationKey)) {
    return false
  }
  if (!nav.access) {
    return true
  }
  return Boolean(user && user[nav.access as keyof IUserWithPortalAccess] === true)
}
